import { render, staticRenderFns } from "./GoodsAndPropertiesPanel.vue?vue&type=template&id=3ce9c998&scoped=true&"
import script from "./GoodsAndPropertiesPanel.vue?vue&type=script&lang=ts&"
export * from "./GoodsAndPropertiesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce9c998",
  null
  
)

export default component.exports